export default __webpack_public_path__ + "static/media/colorWhatIfCurrent.07666417.svg";